import { render, staticRenderFns } from "./MandateSuccess.vue?vue&type=template&id=29f29bcc&scoped=true&"
import script from "./MandateSuccess.vue?vue&type=script&lang=ts&"
export * from "./MandateSuccess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f29bcc",
  null
  
)

export default component.exports